import { render, staticRenderFns } from "./ElementBreadcrumb.vue?vue&type=template&id=282e2a28&"
import script from "./ElementBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./ElementBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./ElementBreadcrumb.vue?vue&type=style&index=0&id=282e2a28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports